module.exports = "/static-assets/_next/static/images/button-texture-d7e19203bbbedcb45aa4b90921cef0e2.png";